import { useUserStore } from '@/store';
import dayjs from '@/utils/dayjs';
import { commonUtils } from './common';
import { storage } from './storage';
import logger from './log';

/** 操作路径 */
const OPERATE_PATH = '__operate_path_';
/** 限制记录的条数 */
const LIMIT = 100;

export enum ErrorManagerEntryType {
  resourceLoad = 'resourceLoad',
  requestApi = 'requestApi',
  vueComponent = 'vueComponent',
  wechatApplication = 'wechatApplication',
}

interface ErrorManagerEntry {
  message?: string;
  stack?: string;
  requestInfo?: {
    url?: string;
    params?: AnyObject;
    statusCode?: number;
    responseData?: AnyObject;
  };
}

// const getNetworkType = () => {
//   return new Promise((resolve, reject) => {
//     uni.getNetworkType({
//       success: function (res) {
//         resolve(res.networkType)
//       },
//       fail: function (err) {
//         reject(err)
//       }
//     });
//   })
// }

const collectError = (errorType: ErrorManagerEntryType, error: ErrorManagerEntry | null) => {
  const systemInfo = uni.getSystemInfoSync();
  const userStore = useUserStore();

  const pages = getCurrentPages();
  const currentPage = pages[pages.length - 1];

  // 错误信息收集对象
  const errorData = {
    errorType, // 错误类型，如"资源加载错误"、"接口请求错误"等
    errorMessage: error?.message, // 错误描述
    errorStack: error?.stack, // 错误堆栈信息

    // 用户相关信息
    userInfo: {
      phoneNumber: userStore.userInfo?.phoneNumber ?? '', // 用户手机号
      nickname: userStore.userInfo?.lastName, // 用户昵称
      loginStatus: userStore.isLogin, // 用户登录状态
      operationPath: storage.get(OPERATE_PATH) ?? [], // 操作路径
      timestamp: new Date().toISOString(), // 错误发生时间
    },

    // 设备相关信息
    deviceInfo: {
      model: systemInfo.model, // 设备型号
      system: systemInfo.system, // 系统版本
      sdkVersion: systemInfo.SDKVersion, // 小程序基础库版本
      // networkType: await getNetworkType()  // 网络类型
    },

    // 页面相关信息
    pageInfo: {
      pageRoute: currentPage?.route, // 当前错误页面的路径
      pageOptions: currentPage?.options, // 页面参数
      pageStack: pages.map((page) => page.route), // 页面栈
    },

    // 请求相关信息（仅在接口请求错误时填充）
    requestInfo: errorType === ErrorManagerEntryType.requestApi ? error?.requestInfo : null,
  };

  return errorData;
};

const errorManager = {
  report: (errorType: ErrorManagerEntryType, error: ErrorManagerEntry | null) => {
    try {
      const errorData = collectError(errorType, error);
      
      logger.error(errorData);
      // storage.set(OPERATE_PATH, [])
      // console.log(`[errorManager-report]`, JSON.stringify(errorData));

      // #ifndef H5
      const filePath = `${uni.env.USER_DATA_PATH}/error_feedback.txt`;

      const fs = uni.getFileSystemManager();

      fs.writeFile({
        filePath,
        data: JSON.stringify(errorData),
        encoding: 'utf-8',
        success: (res) => {
          console.log('文件写入成功', res);
        },
        fail: (err) => {
          console.log('文件写入失败', err);
        },
      });
      // #endif
    } catch (error) {
      console.log(error);
    }
  },
  collectOperatePath: () => {
    const pages = getCurrentPages();
    const currentPage = pages[pages.length - 1];
    let cache = storage.get(OPERATE_PATH) ?? [];

    // console.log(`collectOperatePath cache`, cache);

    // 判断是否当天，不是则清除缓存，重新记录
    if (cache.length > 0 && !commonUtils.date.isSameDay(cache[0].date)) {
      cache = [];
    }

    // 超出限制条数时，先进先出
    if (cache.length >= LIMIT) {
      cache.shift();
    }

    cache.push({
      date: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      path: currentPage.route,
    });

    storage.set(OPERATE_PATH, cache);
  },
};

export default errorManager;
